/*
 * @Author: yuanyunpeng 15226551376@163.com
 * @Date: 2023-05-19 11:18:25
 * @LastEditors: yuanyunpeng 15226551376@163.com
 * @LastEditTime: 2023-06-13 11:03:35
 * @FilePath: \web\src\api\all.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const api = {
  login: {
    getCaptcha: '/api/ajax/getCaptcha',
    index: '/api/login/index',
    regist: 'api/login/add',
    reset: 'api/login/reset',
    send: '/api/login/send',
    logout: '/api/login/logout',
    codeIndex: '/api/login/loginbyphone',
    userinfo: '/api/login/userinfo',
    update: '/api/login/update',
    add: '/api/login/information',
  },
  user: {
    setUserInfo: '/api/login/update',
    getArea: 'api/system.city/index',
  },
  home: {
    solutionInfo: '/api/solution/index',
    requirementInfo: '/api/requirements/index',
    serviceInfo: '/api/service/index',
  },
  upload: {
    upload: '/api/ajax/upload',
  },
  cart: {
    index: '/api/cart/index',
    add: '/api/cart/add',
    detelt: '/api/cart/delete',
    edit: '/api/cart/edit',
  },
  solution: {
    find: '/api/solution/find',
    recommand: '/api/solution.info/index',
    detail: '/api/solution.info/find',
    goodIndex: '/api/goods/index',
    category: '/api/category/getCategorysById',
    financial: '/api/financial.service/index',
  },
  goods: {
    find: '/api/goods/find',
    comment: '/api/goods.comment/index',
    status: '/api/goods/status',
    delete: '/api/goods/delete',
    add: '/api/goods/add',
    edit: '/api/goods/edit',
    addstock: 'api/stock.right/add',
    catalog: 'api/course.content/list',
  },
  order: {
    groupList: '/api/order/grouplist',
    find: '/api/order/find',
    add: '/api/order/add',
    status: '/api/order/status',
    index: 'api/order/listByGoods',
  },
  community: {
    news: '/api/community.news/index',
    software: '/api/community.software/index',
    softwaredetail: '/api/community.software/find',
    newsdetail: '/api/community.news/find',
    addnews: '/api/community.news/add',
    addsoftware: 'api/community.software/add',
  },
  requirement: {
    index: '/api/requirements/index',
    addform: '/api/requirements.form/add',
    toubiao: '/api/requirements/join',
  },
  worktable: {
    pageindex: '/api/requirements/mine',
  },
  shelftable: {
    shelfindex: '/api/course/add',
    index: '/api/course/index',
  },
  shopsetting: {
    getindex: '/api/service/edit',
    find: '/api/service/find',
    comment: '/api/service/comment',
  },
  bid: {
    particList: '',
    partic: '/api/requirements/find',
    deletele: '/api/requirements/delete',
    participate: '/index.php?s=api/requirements.join/index',
    tails: '/api/requirements.join/find',
    contract: '/api/requirements.join/status',
    partrequest: '/api/requirements.join/add',
    editrequest: '/api/requirements.join/edit',
  },
  settlein: {
    attestation: '/api/attestation.person/submit',
  },
  join: {
    shopOrpeople: '/api/attestation.company/submit',
    people: '/api/attestation.person/info',
    getpeople: '/api/attestation.person/index',
    getpeopleDetails: '/api/attestation.person/find',
    ocrjoin: 'api/ocr/ocr',
    attestation:'/api/account.attestation/submit'
  },
  shelf: {
    coursemanage: '/api/goods/add',
    courseedit: '/api/goods/edit',
  },
  cosUpload: {
    api: '/api/system.config/getStsConfig',
  },
};



// WEBPACK FOOTER //
// ./src/api/all.js